import { t } from '../i18n/lingua.js';

/**
 * Un campo con il contatore dei caratteri che restano.
 *
 * Nel v2 sotto certi campi c'è scritto «Caratteri rimanenti: 32». Non è un
 * vezzo: sono i limiti delle tabelle di Business Central, e se un indirizzo
 * li supera **BC rifiuta l'ordine** — al momento dell'invio, con l'ordine già
 * preso. Qui il contatore compare quando ci si avvicina al limite e diventa
 * rosso quando lo si supera, così il problema si vede mentre si scrive.
 */
interface Props {
  id: string;
  etichetta: string;
  valore: string;
  limite?: number;
  obbligatorio?: boolean;
  monospazio?: boolean;
  soloLettura?: boolean;
  larghezzaPiena?: boolean;
  onCambia: (valore: string) => void;
}

export function CampoBc({
  id,
  etichetta,
  valore,
  limite,
  obbligatorio,
  monospazio,
  soloLettura,
  larghezzaPiena,
  onCambia,
}: Props) {
  const restano = limite === undefined ? null : limite - valore.length;
  // il contatore compare solo quando serve: dieci caratteri prima del limite
  const mostraContatore = restano !== null && restano <= 10;

  return (
    <div className={larghezzaPiena ? 'field span-2' : 'field'}>
      <label htmlFor={id}>
        {t(etichetta)}
        {obbligatorio && <span className="req">*</span>}
        {mostraContatore && (
          <span className={restano < 0 ? 'counter over' : 'counter low'}>
            {restano < 0 ? t('{n} di troppo', { n: -restano }) : t('{n} car.', { n: restano })}
          </span>
        )}
      </label>
      <input
        className={monospazio ? 'input mono' : 'input'}
        id={id}
        value={valore}
        readOnly={soloLettura}
        onChange={(e) => onCambia(e.target.value)}
      />
      {restano !== null && restano < 0 && (
        <span className="hint" style={{ color: 'var(--tomato)' }}>
          {t('Business Central rifiuta gli ordini con questo campo più lungo di {n} caratteri.', { n: limite ?? '' })}
        </span>
      )}
    </div>
  );
}
